import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Container from "../components/ui/Container/Container";
import { QueryKey } from "../services/query-keys";
import { IHeaderLink } from "../shared/IHeaderLink";
import ErrorsAlert from "../components/ErrorsAlert/ErrorsAlert";
import { ErrorResponse } from "../custom-fetch";
import Spinner from "../components/ui/Spinner/Spinner";
import HeaderLinkEdit from "../components/Admin/HeaderLinks/HeaderLinkEdit";
import { useHeaderLinksService } from "../services/header-links-service";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { Route } from "../routes";

type Params = {
  id: string;
};

const HeaderLinkPage: React.FC = () => {
  const { id } = useParams<Params>();
  const { fetchHeaderLinks } = useHeaderLinksService();
  
  const {
    data: links,
    isLoading,
    isError,
    error,
  } = useQuery<IHeaderLink[], ErrorResponse>({
    queryKey: [QueryKey.headerLinks],
    queryFn: ({ signal }) => fetchHeaderLinks({ signal }),
    enabled: id !== 'add',
  });

  const link = links?.find(l => l.id === id);

  return (
    <>
      <PageHeading backTo={Route.headerLinks}>{id === 'add' ? 'Add Header Link' : 'Edit Header Link'}</PageHeading>
      <Container>
        {isError ? (
          <ErrorsAlert errors={error.messages} />
        ) : isLoading && id !== 'add' ? (
          <Spinner />
        ) : (
          <HeaderLinkEdit id={id!} link={link} />
        )}
      </Container>
    </>
  );
};

export default HeaderLinkPage;
